<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-spy"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 11h18" />
    <path d="M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4" />
    <path d="M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M10 17h4" />
  </svg>
</template>

<script lang="ts" setup>
export interface IconProps {
  width?: string;
  height?: string;
}

withDefaults(defineProps<IconProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
